import { FieldLabel, Fields } from '@measured/puck';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Switch, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { QuillEditor } from '../../../components/common/quill-editor/quill-editor';

export type TermsAndSubType = {
  isShowTermsAndSub: boolean;
  defaultCollapse: boolean;
  terms: string;
  moreTerms: string;
};

export type TermsAndSubProps = {
  termsAndSub: TermsAndSubType;
};

export const termsAndSubFields: Fields<TermsAndSubProps> = {
  termsAndSub: {
    type: 'custom',
    label: 'Radius',
    render: ({ value, onChange }) => {
      const [isOpen, setIsOpen] = useState(false);

      const toggleAccordion = () => {
        setIsOpen(!isOpen);
      };
      const handleTermsChange = (k: string) => {
        value.terms = k;
        onChange({ ...value, terms: k });
      };
      const handleMoreTermsChange = (k: string) => {
        value.moreTerms = k;
        onChange({
          ...value,
          moreTerms: k,
        });
      };

      return (
        <div>
          <div
            className=" flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
            onClick={toggleAccordion}>
            <h3>Terms And Subscription</h3>
            {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
          </div>
          {isOpen && (
            <div className="flex flex-col gap-4 mt-3 border border-gray-300 rounded p-2 w-full">
              <div>
                <div className="flex justify-between items-center mb-3">
                  <p className="text-sm font-semibold">
                    Show Terms and Subscription
                  </p>
                  <div className="flex gap-0.5 items-center">
                    <Tooltip
                      title={`Toggle this switch to show Terms and Subscription`}
                      placement="top-start">
                      <InfoIcon fontSize="small" className="h-1 w-1" />
                    </Tooltip>
                  </div>
                  <Switch
                    checked={value?.isShowTermsAndSub}
                    onChange={e => {
                      onChange({
                        ...value,
                        isShowTermsAndSub: e.target.checked,
                      });
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
                <FieldLabel label="Terms" el="div">
                  <QuillEditor
                    value={value.terms}
                    onChange={handleTermsChange}
                    id={1}
                  />
                </FieldLabel>
                <div className="flex justify-between items-center mb-3">
                  <p className="text-sm font-semibold">Default Expand</p>
                  <div className="flex gap-0.5 items-center">
                    <Tooltip
                      title={`Toggle this switch to default Expand the Terms and Subscription`}
                      placement="top-start">
                      <InfoIcon fontSize="small" className="h-1 w-1" />
                    </Tooltip>
                  </div>
                  <Switch
                    checked={value.defaultCollapse}
                    onChange={e => {
                      onChange({
                        ...value,
                        defaultCollapse: e.target.checked,
                      });
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
                <FieldLabel label="Extra Terms" el="div">
                  <QuillEditor
                    value={value.moreTerms}
                    onChange={handleMoreTermsChange}
                    id={2}
                  />
                </FieldLabel>
              </div>
            </div>
          )}
        </div>
      );
    },
  },
};
